(function(){
  "use strict";

  // ---- Mobile menu drawer ----
  function bindDrawer(){
    var burger=document.querySelector('[data-burger]');
    var drawer=document.querySelector('[data-drawer]');
    if(!burger||!drawer) return;
    var open=function(){drawer.classList.add('open');document.body.style.overflow='hidden';};
    var close=function(){drawer.classList.remove('open');document.body.style.overflow='';};
    burger.addEventListener('click',open);
    drawer.querySelectorAll('[data-drawer-close],.scrim').forEach(function(el){el.addEventListener('click',close);});
  }

  // ---- Quantity steppers ----
  function bindQty(){
    document.querySelectorAll('[data-qty]').forEach(function(box){
      var input=box.querySelector('input');
      box.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(){
          var step=b.getAttribute('data-step')==='down'?-1:1;
          var v=Math.max(1,(parseInt(input.value,10)||1)+step);
          input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    });
  }

  // ---- Product variant selection ----
  function bindProductForm(){
    var form=document.querySelector('[data-product-form]');
    if(!form) return;
    var dataEl=document.querySelector('[data-variants-json]');
    if(!dataEl) return;
    var variants=[]; try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
    var idInput=form.querySelector('[name="id"]');
    var priceEl=document.querySelector('[data-price]');
    var atcText=document.querySelector('[data-atc-text]');
    var atcBtn=form.querySelector('[data-atc]');
    var mPrice=document.querySelector('[data-m-price]');
    var money=window.JB_money||function(c){return (c/100).toFixed(2).replace('.',',')+' €';};
    var optionGroups=Array.prototype.slice.call(form.querySelectorAll('[data-opt]'));
    var galleryMain=document.querySelector('[data-gallery-main]');

    function currentOptions(){
      return optionGroups.map(function(group){
        var sel=group.querySelector('input:checked');
        return sel?sel.value:null;
      });
    }
    function exactMatch(opts){
      return variants.find(function(v){
        return opts.every(function(o,i){return o!==null&&v.options[i]===o;});
      });
    }
    function optionExists(index,value){
      return variants.some(function(v){return v.options[index]===value;});
    }
    function comboExists(opts){
      return variants.some(function(v){
        return opts.every(function(o,i){return o===null||v.options[i]===o;});
      });
    }
    function setOption(index,value){
      var group=optionGroups[index];
      if(!group) return;
      var input=Array.prototype.find.call(group.querySelectorAll('input'),function(i){return i.value===value;});
      if(input) input.checked=true;
    }
    function coerceSelection(changedIndex){
      var opts=currentOptions();
      var exact=exactMatch(opts);
      if(exact) return exact;

      if(changedIndex!==undefined&&changedIndex!==null&&opts[changedIndex]!==null){
        var changedValue=opts[changedIndex];
        var byChanged=variants.find(function(v){return v.options[changedIndex]===changedValue;});
        if(byChanged){
          byChanged.options.forEach(function(value,index){setOption(index,value);});
          return byChanged;
        }
      }

      var fallback=variants.find(function(v){return v.available;})||variants[0];
      if(fallback) fallback.options.forEach(function(value,index){setOption(index,value);});
      return fallback;
    }
    function updateAvailability(){
      var opts=currentOptions();
      optionGroups.forEach(function(group,index){
        group.querySelectorAll('input').forEach(function(input){
          var test=opts.slice();
          test[index]=input.value;
          var existsForSelection=comboExists(test);
          var existsForOption=optionExists(index,input.value);
          input.disabled=!existsForSelection;
          var label=form.querySelector('label[for="'+input.id+'"]');
          if(label){
            label.classList.toggle('is-unavailable',!existsForSelection);
            label.classList.toggle('is-disabled',!existsForOption);
            label.setAttribute('aria-disabled',(!existsForSelection).toString());
          }
        });
      });
    }
    function updateGallery(v){
      if(!galleryMain||!v||!v.featured_image||!v.featured_image.src) return;
      var img=document.createElement('img');
      img.src=v.featured_image.src;
      img.alt=v.featured_image.alt||'';
      img.width=1000;
      img.height=1000;
      galleryMain.innerHTML='';
      galleryMain.appendChild(img);
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
        var src=t.getAttribute('data-src')||'';
        t.classList.toggle('on',src===v.featured_image.src);
      });
    }
    function update(changedIndex){
      var v=coerceSelection(changedIndex);
      if(!v) return;
      if(idInput) idInput.value=v.id;
      var price=money(v.price);
      var cmp=(v.compare_at_price&&v.compare_at_price>v.price)?(' <s>'+money(v.compare_at_price)+'</s>'):'';
      if(priceEl) priceEl.innerHTML=price+cmp;
      if(mPrice) mPrice.textContent=price;
      if(atcText) atcText.textContent=v.available?('In den Warenkorb · '+price):'Ausverkauft';
      if(atcBtn) atcBtn.disabled=!v.available;
      // update label readouts
      document.querySelectorAll('[data-opt-readout]').forEach(function(r){
        var idx=parseInt(r.getAttribute('data-opt-readout'),10);
        var g=optionGroups[idx];
        var sel=g&&g.querySelector('input:checked'); if(sel) r.textContent=sel.value;
      });
      updateAvailability();
      updateGallery(v);
    }
    optionGroups.forEach(function(group,index){
      group.querySelectorAll('input').forEach(function(input){
        input.addEventListener('change',function(){update(index);});
      });
    });
    update();
  }

  // ---- Product gallery ----
  function bindGallery(){
    var main=document.querySelector('[data-gallery-main]');
    if(!main) return;
    function attr(value){
      return String(value||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    }
    document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        document.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.classList.remove('on');});
        t.classList.add('on');
        var src=t.getAttribute('data-src');
        var srcset=t.getAttribute('data-srcset');
        var alt=t.getAttribute('data-alt')||'';
        if(src){
          var html='<img src="'+attr(src)+'"';
          if(srcset) html+=' srcset="'+attr(srcset)+'" sizes="(min-width: 760px) 50vw, 100vw"';
          html+=' alt="'+attr(alt)+'" width="760" height="760" loading="eager" decoding="async">';
          main.innerHTML=html;
        }
      });
    });
  }

  // ---- Sticky mobile ATC ----
  function bindStickyAtc(){
    var bar=document.querySelector('[data-mobile-atc]');
    var anchor=document.querySelector('[data-atc]');
    if(!bar||!anchor) return;
    var io=new IntersectionObserver(function(e){
      bar.style.display=(e[0].isIntersecting||window.innerWidth>=760)?'none':'flex';
    });
    io.observe(anchor);
  }

  // ---- Free shipping bar (cart) ----
  function bindShipBar(){
    var bar=document.querySelector('[data-shipbar]');
    if(!bar) return;
    var goal=parseInt(bar.getAttribute('data-goal'),10)||4900;
    var total=parseInt(bar.getAttribute('data-total'),10)||0;
    var pct=Math.min(100,Math.round(total/goal*100));
    var fill=bar.querySelector('.fill'); if(fill) fill.style.width=pct+'%';
  }

  function init(){bindDrawer();bindQty();bindProductForm();bindGallery();bindStickyAtc();bindShipBar();}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
